import { Store } from 'src/store/index';

const getTemplateCanAddPages = (store: Store) => store.template.canAddPages;

export default getTemplateCanAddPages;
